const initialState = {
  canCloseThePunchTerminal: false,
  locationId: null,
  loginField: null,
  isPunchToken: false,
  currentBreak: null,
  punchCard: null,
  userInfo: null,
  selectedShift: null
}

const punchTerminal = (state = initialState, action) => {
  switch (action.type) {
    case 'LAUNCH_PUNCH_TERMINAL':
    case 'SET_LOGGED_IN': {
      const {
        decodedToken: { punchToken: isPunchToken, location: locationId, loginField }
      } = action
      return { ...state, isPunchToken, locationId, loginField }
    }
    case 'SET_CAN_CLOSE_PUNCH_TERMINAL':
      return { ...state, canCloseThePunchTerminal: true }
    case 'SET_CURRENT_BREAK':
      return { ...state, currentBreak: action.currentBreak }
    case 'SET_PUNCH_CARD':
      return { ...state, punchCard: action.punchCard }
    case 'SET_SELECTED_SHIFT':
      return { ...state, selectedShift: action.selectedShift }
    case 'OPEN_SESSION':
      return { ...state, userInfo: action.userInfo }
    case 'CLOSE_SESSION':
      return { ...state, punchCard: null, userInfo: null, selectedShift: null, canCloseThePunchTerminal: false }
    case 'CLOSE_PUNCH_TERMINAL':
      return initialState
    default:
      return state
  }
}

export default punchTerminal
